import React from 'react';

import createSvgIcon from '../Utils/CreateSvgIcon';

export const DoubleChevronRight = createSvgIcon(
  <React.Fragment>
    <path
      clipRule="evenodd"
      d="M17.5857 11.9289L11.2218 18.2928L12.636 19.707L20.4142 11.9289L12.636 4.15068L11.2218 5.5649L17.5857 11.9289Z"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M11.5857 11.9289L5.22177 18.2928L6.63599 19.707L14.4142 11.9289L6.63599 4.15068L5.22177 5.5649L11.5857 11.9289Z"
      fillRule="evenodd"
    />
  </React.Fragment>,
  'DoubleChevronRight',
);
